









































import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount, computed } from '@vue/composition-api'
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue"
import PdfRenderArea from "../../components/PdfRenderArea.vue"
import { BModal } from 'bootstrap-vue';
import { PracticeFileUpload } from "../../modules/teacher/PracticeFileUploadDetail"

export interface Data {
  practice_file_upload_id: string
  practiceFileUpload: PracticeFileUpload
  base64Images: string[]
  currentPage: number
  width: number
  height: number
  scale: number
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
    "pdf-render-area": PdfRenderArea,
  },
  setup(props, context){

    const modalFileUploadRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      practice_file_upload_id: null,
      practiceFileUpload: null,
      base64Images: [],
      currentPage: 1,
      width: 0,
      height: 0,
      scale: 0.5,
      errors: [],
    });

    /******************************
     * imgタグのスタイル
     ******************************/

    const imageStyle = computed(() => {
      let style: any = {};
      style["width"] = `${state.width * state.scale}px`;
      style["height"] = `${state.height * state.scale}px`;
      return style;
    });

    /******************************
     * imgの親divのスタイル
     ******************************/

    const imageWrapStyle = computed(() => {
      const style: any = {};
      style["height"] = `${(state.height * state.scale) + 30}px`;
      return style;
    });

    /******************************
     * 拡大ボタン押下
     ******************************/

    const scaleUp = () => {
      state.scale += 0.05;
    }

    /******************************
     * 縮小ボタン押下
     ******************************/

    const scaleDown = () => {
      if(state.scale > 0.1){
        state.scale -= 0.05;
      }
    }

    /************************************************************
     * アップロード
     ************************************************************/

    const upload = async (file: any) => {
      state.errors = [];

      if(!window.confirm("ファイルをアップロードします。よろしいですか？")){
        return;
      }

      let fd = new FormData();
      fd.append('upload[file]', file[0]);
      fd.append('practice_file_upload_id', state.practice_file_upload_id);

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/practice_file_upload_detail_common/upload`, fd).then(async response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.practice_file_upload_id = context.root.$route.params.practice_file_upload_id;
      await http.get(`/api/teacher/practice_file_upload_detail_common?practice_file_upload_id=${state.practice_file_upload_id}`).then(response => {
        state.practiceFileUpload = new PracticeFileUpload(response.data.practice_file_upload);
        state.base64Images = response.data.base64_images;
        state.width = response.data.width;
        state.height = response.data.height;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`データの取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`データの取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalFileUploadRef,
      upload,
      imageStyle,
      imageWrapStyle,
      scaleUp,
      scaleDown,
    };
  }
});

